import { useContext } from 'react';
import { AbilityContext } from '../users/UseUserPermissions';

/**
 * useCanCreateNotes - CASL gate for creating task notes.
 *
 * Notes/review-status access tier model:
 *   - `manage:notes` (Full Access) → all read + write actions, including create
 *   - `read:notes`   (Read Only)   → no create
 */
export const useCanCreateNotes = (): boolean => {
  const ctx = useContext(AbilityContext);

  return ctx?.permissions?.can('manage', 'notes') ?? false;
};
